module.exports = __webpack_public_path__ + "static/img/1-3.ff94333.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1-3.png
// module id = 2prf
// module chunks = 1